export let liveList = [
    {
      "content_id": 682,
      "content_type": 1,
      "cover_img": "https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/images/20220825/77ec07db62b2079cccb8b5b89ce82ef7_20220825114139.jpg",
      "cover_img_s": "",
      "current_count": 3,
      "duration": 0,
      "duration_format": "",
      "id": 677,
      "isAppointment": false,
      "live_status": 0,
      "origin_id": 682,
      "origin_type": 4,
      "start_at": "",
      "title": "儿童淋巴瘤系列精品课",
      "total_count": 12,
      "type": 2,
      "video_id": "",
      "view_count": 3143
    },
    {
      "content_id": 710,
      "content_type": 1,
      "cover_img": "https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/images/20220831/fe188633af86f67b80c4b37e814923df_20220831162316.jpg",
      "cover_img_s": "",
      "current_count": 0,
      "duration": 3467.13,
      "duration_format": "00:57:47",
      "id": 676,
      "isAppointment": false,
      "live_status": 6,
      "origin_id": 710,
      "origin_type": 4,
      "start_at": "2022-09-23 19:00:00",
      "title": "钱文斌教授 | CAR-T细胞疗法治疗B细胞淋巴瘤临床研究进展 ",
      "total_count": 0,
      "type": 3,
      "video_id": "fdfff797c530416fa1677f9856a42ca5",
      "view_count": 3418
    },
    {
      "content_id": 600,
      "content_type": 1,
      "cover_img": "https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/images/20220622/782159938004ed8ffedf569a2083d814_20220622191536.jpg",
      "cover_img_s": "",
      "current_count": 2,
      "duration": 0,
      "duration_format": "",
      "id": 635,
      "isAppointment": false,
      "live_status": 0,
      "origin_id": 600,
      "origin_type": 4,
      "start_at": "",
      "title": "高博医学论坛-第四届淋巴瘤&骨髓瘤免疫与靶向治疗国际高峰论坛",
      "total_count": 2,
      "type": 2,
      "video_id": "",
      "view_count": 45812
    }
  ]
export let columnList = [
  {
    "content_id": 682,
    "content_type": 1,
    "cover_img": "https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/images/20220825/77ec07db62b2079cccb8b5b89ce82ef7_20220825114139.jpg",
    "cover_img_s": "",
    "current_count": 3,
    "duration": 0,
    "duration_format": "",
    "id": 677,
    "isAppointment": false,
    "live_status": 0,
    "origin_id": 682,
    "origin_type": 4,
    "start_at": "",
    "title": "儿童淋巴瘤系列精品课",
    "total_count": 12,
    "type": 2,
    "video_id": "",
    "view_count": 3143,
    "status": 1
  },
  {
    "content_id": 710,
    "content_type": 1,
    "cover_img": "https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/images/20220831/fe188633af86f67b80c4b37e814923df_20220831162316.jpg",
    "cover_img_s": "",
    "current_count": 0,
    "duration": 3467.13,
    "duration_format": "00:57:47",
    "id": 676,
    "isAppointment": false,
    "live_status": 6,
    "origin_id": 710,
    "origin_type": 4,
    "start_at": "2022-09-23 19:00:00",
    "title": "钱文斌教授 | CAR-T细胞疗法治疗B细胞淋巴瘤临床研究进展 ",
    "total_count": 0,
    "type": 3,
    "video_id": "fdfff797c530416fa1677f9856a42ca5",
    "view_count": 3418
  },
  {
    "content_id": 600,
    "content_type": 1,
    "cover_img": "https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/images/20220622/782159938004ed8ffedf569a2083d814_20220622191536.jpg",
    "cover_img_s": "",
    "current_count": 2,
    "duration": 0,
    "duration_format": "",
    "id": 635,
    "isAppointment": false,
    "live_status": 0,
    "origin_id": 600,
    "origin_type": 4,
    "start_at": "",
    "title": "高博医学论坛-第四届淋巴瘤&骨髓瘤免疫与靶向治疗国际高峰论坛",
    "total_count": 2,
    "type": 2,
    "video_id": "",
    "view_count": 45812,
    "status": 1
  }
]
export let academicList = [
  {
    "cover_img": "https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/images/20221111/7368913ea3c0a0aef5eaae56c1444edb_20221111101405.jpg",
    "end_at": "11月13日",
    "end_at_timestamp": 1668326400,
    "id": 7,
    "main_img": "https://gaobo-byh-h5.oss-cn-beijing.aliyuncs.com/meetings/gd/750_nhead.jpeg",
    "meeting_status": 0,
    "start_at": "11月11日",
    "start_at_timestamp": 1668144600,
    "status_text": "未开始",
    "title": "第二届中国老年学和老年医学学会转化医学分会年会",
    "type": 2,
    "uuid": "014058d2"
  },
  {
    "cover_img": "https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/images/20221021/782dededccaa12bd9010b127f8749532_20221021145827.jpg",
    "end_at": "11月11日",
    "end_at_timestamp": 1668139800,
    "id": 6,
    "main_img": "https://gaobo-byh-h5.oss-cn-beijing.aliyuncs.com/meetings/sm/reg_sm.jpg",
    "meeting_status": 1,
    "start_at": "11月9日",
    "start_at_timestamp": 1667953800,
    "status_text": "进行中",
    "title": "中国医学基础学科发展大会",
    "type": 2,
    "uuid": "233c80bc"
  },
  {
    "cover_img": "https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/images/20220114/eac006bded1312d713ce9c53189db255_20220114095722.jpeg",
    "end_at": "1月16日",
    "end_at_timestamp": 1642262400,
    "id": 2,
    "main_img": "https://gaobo-byh-h5.oss-cn-beijing.aliyuncs.com/meetings/68c09fff.jpg?v=2",
    "meeting_status": 2,
    "start_at": "1月14日",
    "start_at_timestamp": 1642089600,
    "status_text": "已结束",
    "title": "第二届中国血液学科发展大会",
    "type": 2,
    "uuid": "68c09fff"
  }
]
export let downList = [
  {
    "created_at": "09月06日",
    "download_count": 18,
    "favorite_count": 1,
    "filesize": 1792,
    "id": 121,
    "isDownload": false,
    "isFavorite": false,
    "link": "https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/pdf/20220906/26cc81f4f34fb7a873c120f05a4a29aa_20220906104123.pdf",
    "title": "双特异性T细胞衔接器治疗急性淋巴细胞白血病指导原则（2022年版）",
    "top": 2,
    "type": 1,
    "type_text": "PDF",
    "view_count": 0
  },
  {
    "created_at": "08月18日",
    "download_count": 17,
    "favorite_count": 1,
    "filesize": 1759,
    "id": 120,
    "isDownload": false,
    "isFavorite": false,
    "link": "https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/pdf/20220818/7263eb9758f8c65feb94a937192ca0f4_20220818171021.pdf",
    "title": "造血干细胞移植后闭塞性细支气管炎综合征诊断与治疗中国专家共识（2022年版）",
    "top": 2,
    "type": 1,
    "type_text": "PDF",
    "view_count": 0
  },
  {
    "created_at": "08月09日",
    "download_count": 17,
    "favorite_count": 1,
    "filesize": 2974,
    "id": 119,
    "isDownload": false,
    "isFavorite": false,
    "link": "https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/pdf/20220809/92edc4ba28f2905cd75e623effd9edca_20220809163435.pdf",
    "title": "靶向B细胞和浆细胞的CAR-T细胞治疗中防治乙型肝炎病毒再激活的中国专家共识（2021年版）",
    "top": 2,
    "type": 1,
    "type_text": "PDF",
    "view_count": 0
  }
]

export let tagList = [
  {
    "id": 3,
    "link": "/#/course-list",
    "logo": "https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/images/20220411/62e3b469f701b8ff9509144d83f7adf3_20220411232346.png",
    "title": "医学专栏",
    "type": 1
  },
  {
    "id": 7,
    "link": "/#/case-list",
    "logo": "https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/images/20220411/00a928990a286e66337014eb4f2f5c44_20220411232413.png",
    "title": "临床好课",
    "type": 1
  },
  {
    "id": 2,
    "link": "/#/meeting-list",
    "logo": "https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/images/20220411/7fb004c47399b09cc2d6c34a6fe5eee1_20220411232353.png",
    "title": "病例实战",
    "type": 1
  },
  {
    "id": 6,
    "link": "/#/article-list",
    "logo": "https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/images/20220411/0f815819c1ce53e02cba49775553c7bf_20220411232401.png",
    "title": "指南共识",
    "type": 1
  },
  {
    "id": 8,
    "link": "/#/activity-list",
    "logo": "https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/images/20220411/b8f421ecf6e1b760d4e3bcaf099586b9_20220411232419.png",
    "title": "学术会议",
    "type": 1
  },
  {
    "id": 9,
    "link": "/#/download-list",
    "logo": "https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/images/20220411/f67215d58bbad71300fd8476b6c7c49a_20220411232424.png",
    "title": "国际视野",
    "type": 1
  },
  {
    "id": 10,
    "link": "https://byh-api.dr-gobroad.com/wechat-phase/urlLink?name=yxjs",
    "logo": "https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/images/20220411/6571b06785be3009c48e493db35174a2_20220411232429.png",
    "title": "荟议日历",
    "type": 1
  },
  {
    "id": 11,
    "link": "/#/topic-detail/1",
    "logo": "https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/images/20220411/15b393955dcfbdec69c70a15fc1a23a5_20220411232437.png",
    "title": "科研好课",
    "type": 2
  },
  {
    "id": 14,
    "link": "/#/topic-detail/17",
    "logo": "https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/images/20220530/cd3008d4c34743fd080150d363e8429a_20220530105446.png",
    "title": "精确诊断",
    "type": 2
  },
  {
    "id": 15,
    "link": "https://byh.dr-gobroad.com/#/topic-detail/3",
    "logo": "https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/images/20220715/c1accc8ef6b47563e45ca3943f76462b_20220715134828.png",
    "title": "医学计算",
    "type": 2
  },
  {
    "id": 13,
    "link": "/#/topic-detail/4",
    "logo": "https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/images/20220516/db1968fa6e82781c856268d10ce733a4_20220516143609.png",
    "title": "大咖辉客室",
    "type": 2
  },
  {
    "id": 12,
    "link": "/#/topic-detail/2",
    "logo": "https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/images/20220418/4f9fab36ecbfe43328fe5b9a8255c17c_20220418200954.png",
    "title": "科研交流群",
    "type": 2
  },
  {
    "id": 2,
    "link": "/#/meeting-list",
    "logo": "https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/images/20220411/7fb004c47399b09cc2d6c34a6fe5eee1_20220411232353.png",
    "title": "血液学科秀",
    "type": 1
  },
  {
    "id": 6,
    "link": "/#/article-list",
    "logo": "https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/images/20220411/0f815819c1ce53e02cba49775553c7bf_20220411232401.png",
    "title": "文献检索",
    "type": 1
  },
  {
    "id": 8,
    "link": "/#/activity-list",
    "logo": "https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/images/20220411/b8f421ecf6e1b760d4e3bcaf099586b9_20220411232419.png",
    "title": "患者招募",
    "type": 1
  },
]
export let msgList = [
  {
    "id": 4,
    "link": "https://mp.weixin.qq.com/s/8G49602aBuX5wvB-B3wcLA",
    "sort": 4,
    "title": "中国医学基础学科发展大会正式开始啦",
    "type": 1
  },
  {
    "id": 3,
    "link": "",
    "sort": 3,
    "title": "李智慧医生：在科研路上乘风破浪，不断进阶迈向“大满贯”！",
    "type": 2
  }
]

export let courseList = [
  {
    "content_id": 682,
    "content_type": 1,
    "cover_img": "https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/images/20220825/77ec07db62b2079cccb8b5b89ce82ef7_20220825114139.jpg",
    "cover_img_s": "",
    "current_count": 3,
    "duration": 0,
    "duration_format": "",
    "id": 677,
    "isAppointment": false,
    "live_status": 0,
    "origin_id": 682,
    "origin_type": 4,
    "start_at": "",
    "title": "儿童淋巴瘤系列精品课",
    "total_count": 12,
    "type": 2,
    "video_id": "",
    "view_count": 3143,
    "status": 1
  },
  {
    "content_id": 710,
    "content_type": 1,
    "cover_img": "https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/images/20220831/fe188633af86f67b80c4b37e814923df_20220831162316.jpg",
    "cover_img_s": "",
    "current_count": 0,
    "duration": 3467.13,
    "duration_format": "00:57:47",
    "id": 676,
    "isAppointment": false,
    "live_status": 6,
    "origin_id": 710,
    "origin_type": 4,
    "start_at": "2022-09-23 19:00:00",
    "title": "钱文斌教授 | CAR-T细胞疗法治疗B细胞淋巴瘤临床研究进展 ",
    "total_count": 0,
    "type": 3,
    "video_id": "fdfff797c530416fa1677f9856a42ca5",
    "view_count": 3418
  },
  {
    "content_id": 600,
    "content_type": 1,
    "cover_img": "https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/images/20220622/782159938004ed8ffedf569a2083d814_20220622191536.jpg",
    "cover_img_s": "",
    "current_count": 2,
    "duration": 0,
    "duration_format": "",
    "id": 635,
    "isAppointment": false,
    "live_status": 0,
    "origin_id": 600,
    "origin_type": 4,
    "start_at": "",
    "title": "高博医学论坛-第四届淋巴瘤&骨髓瘤免疫与靶向治疗国际高峰论坛",
    "total_count": 2,
    "type": 2,
    "video_id": "",
    "view_count": 45812,
    "status": 1
  },
  {
    "content_id": 682,
    "content_type": 1,
    "cover_img": "https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/images/20220825/77ec07db62b2079cccb8b5b89ce82ef7_20220825114139.jpg",
    "cover_img_s": "",
    "current_count": 3,
    "duration": 0,
    "duration_format": "",
    "id": 677,
    "isAppointment": false,
    "live_status": 0,
    "origin_id": 682,
    "origin_type": 4,
    "start_at": "",
    "title": "儿童淋巴瘤系列精品课",
    "total_count": 12,
    "type": 2,
    "video_id": "",
    "view_count": 3143,
    "status": 1
  },
  {
    "content_id": 710,
    "content_type": 1,
    "cover_img": "https://gaobo-byh-h5.oss-accelerate.aliyuncs.com/images/20220831/fe188633af86f67b80c4b37e814923df_20220831162316.jpg",
    "cover_img_s": "",
    "current_count": 0,
    "duration": 3467.13,
    "duration_format": "00:57:47",
    "id": 676,
    "isAppointment": false,
    "live_status": 6,
    "origin_id": 710,
    "origin_type": 4,
    "start_at": "2022-09-23 19:00:00",
    "title": "钱文斌教授 | CAR-T细胞疗法治疗B细胞淋巴瘤临床研究进展 ",
    "total_count": 0,
    "type": 3,
    "video_id": "fdfff797c530416fa1677f9856a42ca5",
    "view_count": 3418
  },
]



// WEBPACK FOOTER //
// ./src/util/staticData.js